import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { MARKETING_EXPENSE_LEGACY_CSS } from './legacyCss';

/** 레거시 CSS 를 이 루트 아래로 한정 — 레거시 화면이 주던 부트스트랩 유틸만 보충 */
export const MarketingExpenseRoot = styled(Box)`
  font-size: 16px;
  color: var(--dk-text-primary, #333);
  & .pt-10 {
    padding-top: 10px;
  }
  & .pb-10 {
    padding-bottom: 10px;
  }
  & .mt-5 {
    margin-top: 5px;
  }
  & .mt-10 {
    margin-top: 10px;
  }
  & .mt-20 {
    margin-top: 20px;
  }
  & .mb-10 {
    margin-bottom: 10px;
  }
  & .mb-20 {
    margin-bottom: 20px;
  }
  & .text-center {
    text-align: center;
  }
  & .text-right {
    text-align: right;
  }
  & .d-flex {
    display: flex;
  }
  & .flex-wrap {
    flex-wrap: wrap;
  }
  & .justify-content-end {
    justify-content: flex-end;
  }
  & .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
  & .table > tbody > tr > td {
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid var(--dk-line-strong, #ddd);
  }
  & .table-fixed {
    table-layout: fixed;
  }
  & hr {
    box-sizing: content-box;
    height: 0;
  }
  ${MARKETING_EXPENSE_LEGACY_CSS}
`;
